import { render, staticRenderFns } from "./JornadaMotorista.vue?vue&type=template&id=30ef2014&"
import script from "./JornadaMotorista.vue?vue&type=script&lang=js&"
export * from "./JornadaMotorista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports